module.exports = __webpack_public_path__ + "static/media/Vaidehi Naik.414241a8.jpg";